import React from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button, Icon } from "semantic-ui-react";
import { toast } from "react-toastify";
import { useMediaQuery } from "react-responsive";
import { changePageScaleFill } from "../../../app/annots/annotSlice";
import { openModal } from "../../../app/common/modals/modalSlice";

export default function PartyDocFillActionButtons() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pageScaleFill } = useSelector((state) => state.annot);
  const { party } = useSelector((state) => state.party);
  const { doc } = useSelector((state) => state.doc);
  const { transaction } = useSelector((state) => state.transaction);
  const isMobile = useMediaQuery({ query: "(max-width:768px)" });

  function closeDocument() {
    navigate(`/party/${party.id}/documents`);
  }

  async function saveAnnots() {
    toast.success("Document successfully saved");
  }

  function handleNotifyAgent() {
    dispatch(
      openModal({
        modalType: "PartyNotifyAgentModal",
        modalProps: {
          doc,
          transaction,
          party,
        },
      }),
    );
  }

  function handleZoomIn() {
    if (pageScaleFill < 4) {
      dispatch(changePageScaleFill(pageScaleFill * 1.25));
    }
  }

  function handleZoomOut() {
    if (pageScaleFill > 0.5) {
      dispatch(changePageScaleFill(pageScaleFill / 1.25));
    }
  }

  return (
    <>
      <div
        className="large horizontal padding background-white"
        style={{
          top: "auto",
          bottom: "0",
          position: "fixed",
          width: "100%",
          height: "80px",
          borderTop: "1px solid #e8e8e8",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            float: "left",
          }}
        >
          <Icon
            size="large"
            color="grey"
            name="minus circle"
            onClick={() => handleZoomOut()}
            style={{ cursor: "pointer" }}
          />
          <p
            className="zero bottom margin"
            style={{
              marginLeft: "3px",
              marginRight: "6px",
              fontWeight: "bold",
            }}
          >
            {Math.round(pageScaleFill * 100)}%
          </p>
          <Icon
            size="large"
            color="grey"
            name="plus circle"
            onClick={() => handleZoomIn()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div
          className="large right margin"
          style={{
            display: "flex",
            alignItems: "center",
            height: "100%",
            float: "right",
          }}
        >
          <Button
            onClick={() => closeDocument()}
            content="Close"
            style={{ marginRight: "10px" }}
          />
          <Button
            color="green"
            onClick={() => handleNotifyAgent()}
            content={isMobile ? "Notify" : "Notify Agent.."}
            style={{ marginRight: "10px" }}
          />
          <Button
            primary
            onClick={() => saveAnnots()}
            content="Save"
            style={{ marginRight: "10px" }}
          />
        </div>
      </div>
    </>
  );
}
